import React, { ReactNode } from "react";
import { LoadingIndicator } from "@/components/ui/LoadingIndicator";
import Icon from "@/components/ui/icons/Icon";
import { IconClassType, isIconClassType } from "@/components/ui/icons/IconClasses";

// icon: none, left, right
// size: small, medium, large
// type: primary, primary2, secondary, tertiary, white, danger, dark, ghost, transparent, active
// btn-radius-100
// https://www.figma.com/design/xnr558XUCXb4vkBy6eAif7/%5B%EB%9D%BC%EC%9D%B4%EB%B8%8C%EB%9F%AC%EB%A6%AC%5D-Potoo-Library?node-id=626-14267&t=3lunUvpzgaQBTI5S-4
export type ButtonProps = {
  type: string;
  label: string | ReactNode;
  icon: string;
  size: string;
  onClick?: () => void;
  iconName?: string | IconClassType;
  iconColor?: string;
  iconSize?: number;
  style?: React.CSSProperties;
  id?: string;
  disabled?: boolean;
  onDisabled?: () => unknown;
  subLabel?: string;
  otherClassName?: string;
  otherProps?: Record<string, unknown>;
  isLoading?: boolean;
};

const Button = (props: ButtonProps) => {
  const {
    type,
    label,
    icon,
    size,
    onClick,
    iconName,
    iconColor,
    iconSize,
    style,
    id,
    disabled = false,
    onDisabled,
    subLabel,
    otherClassName,
    isLoading = false,
  } = props;

  let className = "";
  let iconClassName = "";
  let subClassName = "custom-btn-sublabel ";

  switch (type) {
    case "primary":
      className = "btn-primary ";
      break;
    case "primary1":
      className = "btn-primary btn-primary1 ";
      break;
    case "primary2":
      className = "btn-primary btn-primary2 ";
      break;
    case "secondary":
      className = "btn-secondary ";
      break;
    case "tertiary":
      className = "btn-tertiary ";
      break;
    case "tertiary-black":
      className = "btn-tertiary-black ";
      break;
    case "white":
      className = "btn-white ";
      break;
    case "danger":
      className = "btn-danger ";
      break;
    case "dark":
      className = "btn-dark ";
      break;
    case "ghost":
      className = "btn-ghost ";
      subClassName += "gray-4 ";
      break;
    case "ghost-black":
      className = "btn-ghost-black ";
      subClassName += "gray-4 ";
      break;
    case "active":
      className = "btn-active ";
      break;
    case "transparent":
      className = "btn-transparent ";
      break;
  }

  switch (icon) {
    case "left":
      iconClassName = iconClassName + "icon-left ";
      break;
    case "right":
      iconClassName = iconClassName + "icon-right ";
      break;
    case "center":
      iconClassName = iconClassName + "icon-center ";
      break;
    case "pencil":
      iconClassName = iconClassName + "icon-pencil";
      break;
  }

  switch (size) {
    case "small":
      className = className + "size-small ";
      iconClassName = iconClassName + "icon-small ";
      break;
    case "medium":
      className = className + "size-medium ";
      iconClassName = iconClassName + "icon-medium ";
      break;
    case "large":
      className = className + "size-large ";
      iconClassName = iconClassName + "icon-large ";
      break;
  }

  // 글자 개수가 10개 이상이면 long-text 클래스 추가
  const getLabelClassName = (label: string) => {
    return label.length >= 10 ? "label long-text" : "label";
  };

  if (isLoading) {
    return (
      <button className={`${className} ${otherClassName} is-loading`} style={style} id={id}>
        <LoadingIndicator size={size} />
      </button>
    );
  }

  //disable인데 눌렀을 때 무언가 발동해야하는 경우
  else if (disabled && onDisabled)
    return (
      <button
        onClick={onDisabled}
        className={`${className} ${otherClassName} is-disabled`}
        style={style}
        id={id}
      >
        {icon === "left" && !isIconClassType(iconName) && (
          <i className={`${iconName} ${iconClassName}`} />
        )}
        {icon === "left" && isIconClassType(iconName) && (
          <Icon name={iconName} className={iconClassName} size={iconSize} />
        )}

        <span className="label">{label}</span>

        {icon === "center" && isIconClassType(iconName) && (
          <Icon name={iconName} className={iconClassName} size={iconSize} />
        )}

        {subLabel && <span className={`caption-700 ${subClassName}`}>{subLabel}</span>}

        {/* {icon === "right" && <i className={`${iconName} ${iconClassName}`} />} */}
        {icon === "right" && !isIconClassType(iconName) && (
          <i className={`${iconName} ${iconClassName}`} />
        )}
        {icon === "right" && isIconClassType(iconName) && (
          <Icon name={iconName} className={iconClassName} size={iconSize} />
        )}
      </button>
    );

  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`${className} ${otherClassName} ${disabled ? "is-disabled" : ""} `}
      style={style}
      id={id}
    >
      {/* {icon === "left" && (
        <i className={`${iconName} ${iconClassName} ${iconColor}`} />
      )} */}
      {icon === "left" && !isIconClassType(iconName) && (
        <i className={`${iconName} ${iconClassName} ${iconColor}`} />
      )}
      {icon === "left" && isIconClassType(iconName) && (
        <Icon name={iconName} className={`${iconClassName} ${iconColor}`} size={iconSize} />
      )}
      <div className="label-container">
        <span className={getLabelClassName(label as string)}>{label}</span>
      </div>

      {icon === "center" && isIconClassType(iconName) && (
        <Icon name={iconName} className={`${iconClassName} ${iconColor}`} size={iconSize} />
      )}

      {subLabel && <span className={`caption-700 ${subClassName}`}>{subLabel}</span>}

      {/* {icon === "right" && (
        <i className={`${iconName} ${iconClassName} ${iconColor}`} />
      )} */}
      {icon === "right" && !isIconClassType(iconName) && (
        <i className={`${iconName} ${iconClassName} ${iconColor}`} />
      )}
      {icon === "right" && isIconClassType(iconName) && (
        <Icon name={iconName} className={`${iconClassName} ${iconColor}`} size={iconSize} />
      )}

    </button>
  );
};

export { Button };
